// https://storybook.js.org/tutorials/design-systems-for-developers/react/en/build/
import styled from "styled-components";
import { createGlobalStyle, css } from 'styled-components';
import {GatsbyImage} from "gatsby-plugin-image";

// font files is a local woff
// export const fontUrl = 'https://fonts.googleapis.com/css?family=Nunito+Sans:400,700,800,900';

export const colors = {
  black: '#171d21',
  charcoal: '#181E24',
  red: '#8A0A2C',
  gold: '#A88D5D',
  grey: '#767676',
  lightgrey: '#F5F5F5',
  white: '#FFF',
  offwhite: '#fafbfd',
  lightbrown: '#f7f7f7'
};

export const Section = styled.section`
  width: 100%;
  padding: 2rem 0;
  position: relative;
  @media(min-width: 768px) {
    padding: 4rem 0;
  }
`;

export const Container = styled.div`
  max-width: var(--content-width-max);
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  z-index: 1;
  @media(min-width: 768px) {
    padding: 0 1rem;
  }
`;

export const NarrowContainer = styled(Container)`
  @media (min-width: 768px) {
    padding: 0 4rem;
  }
  @media (min-width: 1600px) { --content-width-max: 1200px; }
`

export const BackgroundImage = styled(GatsbyImage)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
`;

export const MaxWidth = css`
  max-width: var(--content-width-max);   
  margin: auto;
`;

export const GreyWhiteSplitBkg = css`
  background: linear-gradient(0deg, #fff 50%, #E9ECEF 50%)
`
export const WhiteGreySplitBkg = css`
  background: linear-gradient(180deg, #fff 50%, #E9ECEF 50%)
`
